/** Light validation / normalize for seller billing fields on profiles. */

export function normalizeVatNumber(value: string): string {
  return value.replace(/[\s.-]/g, '').toUpperCase();
}

/** Empty OK. FR: FR + 2 char key + 9-digit SIREN. Other EU: 2-letter country + 2–12 alnum. */
export function isValidVatNumber(value: string, options?: { allowEmpty?: boolean }): boolean {
  const allowEmpty = options?.allowEmpty ?? true;
  const v = normalizeVatNumber(value);
  if (!v) return allowEmpty;
  if (/^FR[A-Z0-9]{2}\d{9}$/.test(v)) return true;
  return /^[A-Z]{2}[A-Z0-9]{2,12}$/.test(v);
}

export function normalizeIban(value: string): string {
  return value.replace(/[\s.-]/g, '').toUpperCase();
}

export function formatIbanDisplay(value: string): string {
  const compact = normalizeIban(value);
  return compact.replace(/(.{4})/g, '$1 ').trim();
}

/** Empty OK. Basic structure + FR length 27 when FR. */
export function isValidIban(value: string, options?: { allowEmpty?: boolean }): boolean {
  const allowEmpty = options?.allowEmpty ?? true;
  const iban = normalizeIban(value);
  if (!iban) return allowEmpty;
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
  if (iban.startsWith('FR') && iban.length !== 27) return false;
  return iban.length >= 15 && iban.length <= 34;
}

export function normalizeBic(value: string): string {
  return value.replace(/[\s.-]/g, '').toUpperCase();
}

/** Empty OK. BIC/SWIFT: 8 or 11 alphanumeric. */
export function isValidBic(value: string, options?: { allowEmpty?: boolean }): boolean {
  const allowEmpty = options?.allowEmpty ?? true;
  const bic = normalizeBic(value);
  if (!bic) return allowEmpty;
  return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bic);
}

export function normalizeCountryCode(value: string): string {
  return value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2);
}

export function normalizePostalCode(value: string): string {
  return value.trim().slice(0, 16);
}
